import React, { useEffect, useMemo, useState } from 'react';

import Pagination from 'components/Pagination/pagination';
import {
    Row,
    Col,
    Container,
    Tableau,
    TableauHeader,
    TableauRow,
    TableauHeaderCell,
    TableauBody,
    TableauCell,
    Button,
    SegmentLoader,
} from '@si-armes/dsfr-react';
import { connect } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import PropTypes from 'prop-types';
import {
    displayStatutImportEnMasse,
    telechargerFichierDepuisContenu,
} from '../../../../../utils/utils';
import usagerClientReducer from '../../../../../store/usagerReducer';
import {
    CONTEXT_AJOUT_ARME_EN_MASSE_FICHIER_IMPORTE,
    CONTEXT_AJOUT_ARME_EN_MASSE_FICHIERS_IMPORTES,
    CONTEXT_AJOUT_ARME_EN_MASSE_RAPPORT_ERREUR,
    CONTEXT_AJOUT_ARME_EN_MASSE_RAPPORT_SUCCES,
    DOWNLOAD_FICHIER_TRAITEMENT_EN_MASSE_URL,
    FICHIER_TYPE_FICHIER_IMPORTE,
    FICHIER_TYPE_RAPPORT_ERRORS,
    FICHIER_TYPE_RAPPORT_SUCCESS,
    GET_FICHIERS_TRAITEMENT_EN_MASSE_URL,
} from '../../../../../constants/apiUrls.constants';
import { MIME_TEXT_CSV } from '../../../../../constants/fileConstant';
import BoutonFichierTelechargeable from '../../../../../components/Commun/Fichier/BoutonFichierTelechargeable';
import { getStatusFileImportedById } from '../../../../../constants/ajoutArmeEnMasse.constants';

const Resultats = ({
    armes,
    isLoading,
    getApi,
    postApi,
    isLoadingFichierImporte,
    reinitialiseApi,
    fichierImporteArmeEnMasse,
    isLoadingRapportErreur,
    isLoadingRapportSucces,
    rapportErreur,
    rapportSucces,
}) => {
    const [ordreTri, setOrdreTri] = useState('ASC');
    const [champTri, setChampTri] = useState('statutCourant');
    const [currentPage, setCurrentPage] = useState(1);
    const [limitPerPage, setLimitPerPage] = useState(10);
    const optionsPaginations = [
        { name: '10', value: '10' },
        { name: '30', value: '30' },
        { name: '50', value: '50' },
        { name: '100', value: '100' },
    ];

    const donneesTriees = useMemo(() => {
        if (!armes) return [];

        return [...armes].sort((a, b) => {
            let valA = a[champTri];
            let valB = b[champTri];

            if (champTri === 'dateInit' || champTri === 'dateMaj') {
                valA = new Date(valA);
                valB = new Date(valB);
            }

            if (!valA) return 1;
            if (!valB) return -1;

            if (valA < valB) return ordreTri === 'ASC' ? -1 : 1;
            if (valA > valB) return ordreTri === 'ASC' ? 1 : -1;
            return 0;
        });
    }, [armes, ordreTri, champTri]);

    const totalPages = useMemo(() => {
        return Math.ceil((donneesTriees?.length || 0) / limitPerPage);
    }, [donneesTriees, limitPerPage]);

    const desactiverPaginationSuivante = currentPage >= totalPages;

    const donneesPaginees = useMemo(() => {
        if (!donneesTriees) return [];
        const startIndex = (currentPage - 1) * limitPerPage;
        return donneesTriees.slice(startIndex, startIndex + limitPerPage);
    }, [donneesTriees, currentPage, limitPerPage]);

    const goToNextPage = () => {
        setCurrentPage((prevPage) => prevPage + 1);
    };

    const goToPreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    };

    const onChangePagination = (value) => {
        setLimitPerPage(parseInt(value, 10));
        setCurrentPage(1);
    };

    const entete = [
        { field: 'libelle', header: 'Nom du fichier importé' },
        { field: 'statutCourant', header: 'Statut' },
        { field: 'dateInit', header: "Date d'import" },
        { field: 'dateMaj', header: 'Date de résultat' },
        { field: 'cheminRapportErreur', header: "Rapport d'erreur" },
        { field: 'cheminRapportSucces', header: "Rapport d'import" },
    ];

    useEffect(() => {
        getApi(
            usagerClientReducer,
            GET_FICHIERS_TRAITEMENT_EN_MASSE_URL,
            CONTEXT_AJOUT_ARME_EN_MASSE_FICHIERS_IMPORTES,
        );
    }, []);

    useEffect(() => {
        if (!isLoadingFichierImporte && fichierImporteArmeEnMasse) {
            telechargerFichierDepuisContenu(
                fichierImporteArmeEnMasse.contenu,
                fichierImporteArmeEnMasse.libelle,
            );
        }
    }, [isLoadingFichierImporte]);

    useEffect(() => {
        if (!isLoadingRapportErreur && rapportErreur) {
            telechargerFichierDepuisContenu(rapportErreur.contenu, rapportErreur.libelle);
        }
    }, [isLoadingRapportErreur]);

    useEffect(() => {
        if (!isLoadingRapportSucces && rapportSucces) {
            telechargerFichierDepuisContenu(rapportSucces.contenu, rapportSucces.libelle);
        }
    }, [isLoadingRapportSucces]);

    const telechargerFichierImporte = (id) => {
        reinitialiseApi(CONTEXT_AJOUT_ARME_EN_MASSE_FICHIER_IMPORTE);
        const url = DOWNLOAD_FICHIER_TRAITEMENT_EN_MASSE_URL.replace('{id}', id).replace(
            '{type}',
            FICHIER_TYPE_FICHIER_IMPORTE,
        );
        postApi(usagerClientReducer, url, {}, CONTEXT_AJOUT_ARME_EN_MASSE_FICHIER_IMPORTE);
    };

    const telechargerRapportSucces = (id) => {
        reinitialiseApi(CONTEXT_AJOUT_ARME_EN_MASSE_RAPPORT_SUCCES);
        const url = DOWNLOAD_FICHIER_TRAITEMENT_EN_MASSE_URL.replace('{id}', id).replace(
            '{type}',
            FICHIER_TYPE_RAPPORT_SUCCESS,
        );
        postApi(usagerClientReducer, url, {}, CONTEXT_AJOUT_ARME_EN_MASSE_RAPPORT_SUCCES);
    };

    const telechargerRapportErreur = (id) => {
        reinitialiseApi(CONTEXT_AJOUT_ARME_EN_MASSE_RAPPORT_ERREUR);
        const url = DOWNLOAD_FICHIER_TRAITEMENT_EN_MASSE_URL.replace('{id}', id).replace(
            '{type}',
            FICHIER_TYPE_RAPPORT_ERRORS,
        );
        postApi(usagerClientReducer, url, {}, CONTEXT_AJOUT_ARME_EN_MASSE_RAPPORT_ERREUR);
    };

    function formatDate(date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }

    return (
        <Container>
            <Row>
                <Col col={12}>
                    <h3>Liste des résultats des imports</h3>
                    <Row className="center">
                        <Col col={6}>
                            <Button
                                name="Rafraichir"
                                variant="secondary"
                                onClick={() => {
                                    getApi(
                                        usagerClientReducer,
                                        GET_FICHIERS_TRAITEMENT_EN_MASSE_URL,
                                        CONTEXT_AJOUT_ARME_EN_MASSE_FICHIERS_IMPORTES,
                                    );
                                }}
                            >
                                Rafraichir
                            </Button>
                        </Col>
                        <Col col={6}>
                            <Pagination
                                currentPage={currentPage}
                                goToPreviousPage={goToPreviousPage}
                                goToNextPage={goToNextPage}
                                limitPerPage={limitPerPage}
                                onChangePagination={onChangePagination}
                                optionsPaginations={optionsPaginations}
                                desactiverPaginationSuivante={desactiverPaginationSuivante}
                            />
                        </Col>
                    </Row>
                    <SegmentLoader isLoading={isLoading}>
                        <Tableau avecBordure role="table" noCaption>
                            <TableauHeader>
                                <TableauRow>
                                    {entete.map((title) => (
                                        <TableauHeaderCell
                                            ordreTri={
                                                champTri === title.field ? ordreTri : undefined
                                            }
                                            onClick={() => {
                                                setCurrentPage(1);

                                                if (champTri === title.field) {
                                                    setOrdreTri((old) =>
                                                        old === 'ASC' ? 'DESC' : 'ASC',
                                                    );
                                                } else {
                                                    setOrdreTri('ASC');
                                                    setChampTri(title.field);
                                                }
                                            }}
                                            scope="col"
                                            key={title.field}
                                        >
                                            {title.header}
                                        </TableauHeaderCell>
                                    ))}
                                </TableauRow>
                            </TableauHeader>
                            <TableauBody>
                                {donneesPaginees.map((arme) => {
                                    const dateInit = new Date(arme.dateInit);
                                    const dateMaj = new Date(arme.dateMaj);

                                    const status = getStatusFileImportedById(arme.statutCourant);

                                    return (
                                        <>
                                            <TableauRow>
                                                <TableauCell>
                                                    <BoutonFichierTelechargeable
                                                        titreFichier={arme.libelle}
                                                        mimeType={MIME_TEXT_CSV}
                                                        label={arme.libelle}
                                                        handleOnClick={() =>
                                                            telechargerFichierImporte(arme.id)
                                                        }
                                                    />
                                                </TableauCell>
                                                <TableauCell style={{ whiteSpace: 'nowrap' }}>
                                                    {displayStatutImportEnMasse({
                                                        label: status?.libelle,
                                                        system: status?.system,
                                                    })}
                                                </TableauCell>
                                                <TableauCell>{formatDate(dateInit)}</TableauCell>
                                                <TableauCell>{formatDate(dateMaj)}</TableauCell>
                                                <TableauCell>
                                                    {arme.nombreErreur > 0 && (
                                                        <BoutonFichierTelechargeable
                                                            titreFichier={arme.libelle}
                                                            mimeType={MIME_TEXT_CSV}
                                                            handleOnClick={() =>
                                                                telechargerRapportErreur(arme.id)
                                                            }
                                                            label="Télécharger"
                                                            iconOnly
                                                        />
                                                    )}
                                                </TableauCell>
                                                <TableauCell>
                                                    {arme.nombreSucces > 0 && (
                                                        <BoutonFichierTelechargeable
                                                            titreFichier={arme.libelle}
                                                            mimeType={MIME_TEXT_CSV}
                                                            handleOnClick={() =>
                                                                telechargerRapportSucces(arme.id)
                                                            }
                                                            iconOnly
                                                            label="Télécharger"
                                                        />
                                                    )}
                                                </TableauCell>
                                            </TableauRow>
                                        </>
                                    );
                                })}
                            </TableauBody>
                        </Tableau>
                    </SegmentLoader>
                </Col>
            </Row>
        </Container>
    );
};

Resultats.propTypes = {
    getApi: PropTypes.func.isRequired,
    postApi: PropTypes.func.isRequired,
    isLoadingFichierImporte: PropTypes.bool,
    isLoadingRapportErreur: PropTypes.bool,
    isLoadingRapportSucces: PropTypes.bool,
    reinitialiseApi: PropTypes.func.isRequired,
    fichierImporteArmeEnMasse: PropTypes.object,
    rapportErreur: PropTypes.object,
    rapportSucces: PropTypes.object,
    isLoading: PropTypes.bool,
    armes: PropTypes.shape({
        sort: PropTypes.func,
        uniquid: PropTypes.string,
        statutCourant: PropTypes.string,
        libelle: PropTypes.string,
        cheminFichierImport: PropTypes.string,
        cheminRapportErreur: PropTypes.string,
        cheminRapportSucces: PropTypes.string,
        nombre: PropTypes.number,
        nombreTraite: PropTypes.number,
        nombreErreur: PropTypes.number,
        nombreSucces: PropTypes.number,
        id: PropTypes.string,
        dateInit: PropTypes.string,
        dateMaj: PropTypes.string,
    }),
};

export default connect(
    (state) => {
        const { data: armes, isLoading } = state.armes.ajoutArmeEnMasse.fichiersImportes;
        const { data: fichierImporteArmeEnMasse, isLoading: isLoadingFichierImporte } =
            state.armes.ajoutArmeEnMasse.fichierImporte;
        const { data: rapportErreur, isLoading: isLoadingRapportErreur } =
            state.armes.ajoutArmeEnMasse.fichierRapportErreur;

        const { data: rapportSucces, isLoading: isLoadingRapportSucces } =
            state.armes.ajoutArmeEnMasse.fichierRapportSucces;

        return {
            armes,
            isLoading,
            fichierImporteArmeEnMasse,
            isLoadingFichierImporte,
            isLoadingRapportSucces,
            isLoadingRapportErreur,
            rapportErreur,
            rapportSucces,
        };
    },
    {
        getApi: getAPI,
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(Resultats);
